<template>
  <div>
    <MainNavBar />
    <Hero :hero="heroProjects" />
    <SectionProjects :learnMoreOverride="true" />
    <section-supply-chain-collab />
    <CallToAction :content="projectsCTA" />
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import SectionProjects from '@/components/section-projects.vue';
import SectionSupplyChainCollab from '@/components/section-supply-chain-collab.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
export default {
  name: 'Projects',
  components: {
    MainNavBar,
    Hero,
    Section,
    SectionProjects,
    SectionSupplyChainCollab,
    CallToAction,
    GmxFooter
  },
  data() {
    return { 
      heroProjects: { 
        eyebrow: 'Decentralized collaboration, management, and search',
        header: 'Secure Supply Chain Digital-Twin Collaboration',
        subheader: 'Collaborate, manage, and search hundreds of projects using secure decentralized Solid compliant storage.',
        img: '',
        videoId: '683264838',
        buttons: [
        ]
      },
      /*projects: { 
        header: 'TrinApp\u2122 Projects',
        headerIcon: 'trinapp_projects.png',
        id: 'projects',
        image: 'project-pods.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
        html: 
          '<div class="pl-md-5 px-3 pb-5">' + 
          ' <p>What it does for you:</p>' + 
          ' <ul>' + 
          '  <li>Collaborate and manage projects in decentralized, Solid compliant storage.</li>' + 
          '  <li>Search across hundreds of projects each containing thousands of documents.</li>' + 
          ' </ul>' + 
          ' <p>Better than current solutions:</p>' + 
          ' <ul>' + 
          '  <li>Find the information you need to take action in seconds.</li>' + 
          '  <li>State-of-the-art Security.</li>' + 
          '  <li>High Performance with any number of projects, each with any number of documents and any amount of data.</li>' + 
          '  <li>100% ownership and control of your data.</li>' + 
          '  <li>Detailed access control, version control, history.</li>' + 
          '  <li>Your project data is free from apps that create silos. Share the data with any Solid compliant app.</li>' + 
          ' </ul>' + 
          '</div>'
      },*/
      projectsCTA: {
        header: 'Start using TrinPod\u2122',
        bgClass: 'text-dark bg-light-grad',
        btnText: 'Contact us',
        btnVariant: 'neon-blue'
      }
    }
  }
};
</script>

<!--style>
html {
  scroll-behavior: smooth;
}
</style-->
